/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	sellTotal: 0,
	sells: [],
	provinces: [],
	places: [],
	shippings: [],
	shippingsTotal: 0,
	matchings: [],
	matchingsTotal: 0,
	suppliers: [],
	myOrders: [],
	products: [],
	myOrdersTotal: 0,
	total: 0,
	users2: [],
	total2: 0,
	users3: [],
	total3: 0,
	limit: 10,
};
